<template>
  <div>
    <div class="widget-list widget-list-rounded m-b-30" data-id="widget">
      <a href="#" @click="fn_set('gift_newuser')" class="widget-list-item">
        <div class="widget-list-media icon">
          <i class="fa fa-gift bg-blue text-white"></i>
        </div>
        <div class="widget-list-content">
          <h4 class="widget-list-title">新人注册优惠券</h4>
        </div>
        <div class="widget-list-action text-nowrap text-grey-darker" v-if="giftset['gift_newuser']">
          {{giftset['gift_newuser'].remarks}}
          <i
            class="fa fa-angle-right text-muted t-plus-1 fa-lg m-l-5"
          ></i>
        </div>
      </a>
      <a href="#" @click="fn_set('gift_afterorder')" class="widget-list-item">
        <div class="widget-list-media icon">
          <i class="fa fa-gift bg-indigo text-white"></i>
        </div>
        <div class="widget-list-content">
          <h4 class="widget-list-title">付款后赠送优惠券</h4>
        </div>
        <div
          class="widget-list-action text-nowrap text-grey-darker"
          v-if="giftset['gift_afterorder']"
        >
          {{giftset['gift_afterorder'].remarks}}
          <i
            class="fa fa-angle-right text-muted t-plus-1 fa-lg m-l-5"
          ></i>
        </div>
      </a>
    </div>
    <Drawer :closable="true" title="设置" width="50" v-model="v_show">
      <Form :labelWidth="120">
        <FormItem label="优惠券">
          <Select label-in-value v-model="couponid">
            <Option
              :value="item.id"
              :label="item.title"
              v-for="(item,index) in couponList"
              :key="index"
            ></Option>
          </Select>
        </FormItem>
        <FormItem label>
          <div class="row">
            <div class="col-md-3">
              <button type="button" class="btn btn-theme" @click="fn_save">保存</button>
            </div>
            <div class="col-md-3">
              <button type="button" class="btn btn-danger" @click="fn_clear">清除</button>
            </div>
          </div>
        </FormItem>
      </Form>
    </Drawer>
  </div>
</template>
<script>
import { getEnumByCode, saveEnumData } from "@/api/config";
import { getActivityList } from "@/api/activity";
export default {
  data() {
    return {
      giftset: {},
      v_show: false,
      code: "",
      couponid: 0,
      couponname: "",
      couponList: []
    };
  },
  mounted() {
    getEnumByCode("gift_newuser,gift_afterorder")
      .then(res => {
        this.giftset = res.data;
      })
      .catch(error => {
        this.$Message.error(error);
      });
  },
  methods: {
    fn_set(code) {
      this.code = code;
      this.couponid = this.giftset[code].id;
      this.v_show = true;

      let jointype = "";
      if (code == "gift_newuser") {
        jointype = "follow";
      } else if (code == "gift_afterorder") {
        jointype = "buy";
      }

      getActivityList({
        pageNum: 0,
        page: 0,
        title: "",
        activitytype: "coupon",
        jointype: jointype
      })
        .then(res => {
          this.couponList = res.data;
        })
        .catch(error => {
          this.$Message.error(error);
        });
    },

    fn_save() {
      //   console.log(this.code, this.couponid, this.couponname);
      let thiscouponname = this.couponname;
      for (let index = 0; index < this.couponList.length; index++) {
        const element = this.couponList[index];
        if (element.id == this.couponid) {
          thiscouponname = element.title;
          break;
        }
      }
      saveEnumData({
        code: this.code,
        value: this.couponid,
        remarks: thiscouponname
      })
        .then(res => {
          if (res.data.code == 200) {
            this.$Notice.success(res.data);
            this.v_show = false;
            this.giftset[this.code].remarks = thiscouponname;
          } else {
            this.$Notice.error(res.data);
          }
        })
        .catch(error => {
          this.$Message.error(error);
        });
    },
    fn_clear() {
      saveEnumData({
        code: this.code,
        value: 0,
        remarks: ""
      })
        .then(res => {
          if (res.data.code == 200) {
            this.$Notice.success(res.data);
            this.v_show = false;
            this.giftset[this.code].remarks = "";
          } else {
            this.$Notice.error(res.data);
          }
        })
        .catch(error => {
          this.$Message.error(error);
        });
    }
  }
};
</script>